[
  {
    "name": "Claude Code",
    "what": "Anthropic coding agent. Needs a Claude Pro, Max, Team or Console account.",
    "install": {
      "mac": "curl -fsSL https://claude.ai/install.sh | bash",
      "windows": "irm https://claude.ai/install.ps1 | iex"
    },
    "signIn": "Then type claude, press Enter and sign in in the browser window that opens."
  },
  {
    "name": "Codex CLI",
    "what": "OpenAI coding agent. Needs a ChatGPT plan or an OpenAI API account. Requires Node.js.",
    "install": {
      "mac": "npm install -g @openai/codex",
      "windows": "npm install -g @openai/codex"
    },
    "signIn": "Then type codex, press Enter and choose Sign in with ChatGPT."
  },
  {
    "name": "Ollama",
    "what": "Runs open models on the computer itself (free, needs a decent GPU or Apple silicon).",
    "install": {
      "mac": "Download and open the installer from https://ollama.com/download",
      "windows": "Download and run the installer from https://ollama.com/download"
    },
    "signIn": "Then download a model, for example: ollama pull qwen3"
  },
  {
    "name": "LM Studio",
    "what": "Desktop app for local models such as Qwen.",
    "install": {
      "mac": "Download and open LM Studio from https://lmstudio.ai",
      "windows": "Download and run LM Studio from https://lmstudio.ai"
    },
    "signIn": "Open LM Studio once and download a model; that also installs its lms command."
  }
]
